// extracted by mini-css-extract-plugin
export default {"slider":"styles_slider__I4qNQ"};